/*
 * Base class for all Element shapes.
 * 
 */
export function AbstractElementConstructor(services, callbacks, context, siteTypeConfig) {
  
  const DEFAULT_BOX_WIDTH = 250;
  const joint = services.joint;

  return joint.shapes.devs.Model.extend({
    markup: '<g class="rotatable"><rect class="body"/></g>',
    defaults: joint.util.deepSupplement({
      z: 20,
      size: { width: DEFAULT_BOX_WIDTH, height: 50 },
      attrs: {
        '.body': {stroke: 'none', 'fill': '#F5F5F5', 'fill-opacity': 0.9},
      },
    }, joint.shapes.devs.Model.prototype.defaults)
  });
}


export function AbstractNonDragableElementConstructor(services, callbacks, context, siteTypeConfig) {

  const joint = services.joint;

  return joint.shapes.html.AbstractElement.extend({
    defaults: joint.util.deepSupplement({
      attrs: {
        rect: {'pointer-events': 'none'}, // Prevent box from moving
      },
    }, joint.shapes.html.AbstractElement.prototype.defaults)
  });
}


export function AbstractElementWithOutPortConstructor(services, callbacks, context, siteTypeConfig) {

  const joint = services.joint;

  return joint.shapes.html.AbstractElement.extend({
    portLabelMarkup: '',
    defaults: joint.util.deepSupplement({
      outPorts: ['out'],
      ports: {
        groups: {
          'out': {
            attrs: {
              '.port-body': {
                fill: '#fff',
                stroke: 'red',  // initially an out port is red 
                'stroke-width': '3',
              },
              '.port-label': {
                'pointer-events': 'none'
              }
            }
          }
        }
      },
    }, joint.shapes.html.AbstractElement.prototype.defaults)
  });
}


export function AbstractNonDragableElementWithOutPortConstructor(services, callbacks, context, siteTypeConfig) {

  const joint = services.joint;

  return joint.shapes.html.AbstractElementWithOutPort.extend({
    defaults: joint.util.deepSupplement({
      attrs: {
        rect: {'pointer-events': 'none'}, // Prevent box from moving
      },
    }, joint.shapes.html.AbstractElementWithOutPort.prototype.defaults)
  });
}
